// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__33W6j","controls":"styles_controls__2hMB9","charLimit":"styles_charLimit__3nplt","input":"styles_input__1a0wF","send":"styles_send__Wdb5g"};